export default function Footer() {
    return (
        <>
            {/* Start Footer Area */}
            <div className="footer-area">
                <div className="container">
                    <a target="_blank" href="http://www.visitrijssenholten.nl/" rel="noreferrer">
                        <img src="/assets/images/footer-logo.svg" alt="footer-logo" />
                    </a>
                </div>
            </div>
            {/* End Footer Area */}
            <div className="right-option-wrap">
                <div className="d-flex align-items-center">
                    <img src="/assets/images/right-option.png" className="right-option" alt="right-option" />
                    <a href="/">
                        <img src="/assets/images/right-text.png" className="right-text" alt="right-text" />
                    </a>
                </div>
            </div>
            {/* Start Go Top Area */}
            <div className="go-top">
                <i className="ri-arrow-up-s-fill" />
                <i className="ri-arrow-up-s-fill" />
            </div>
            {/* End Go Top Area */}
        </>
    );
}
